import { render } from "./Switch.vue?vue&type=template&id=03df671b&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=03df671b&scoped=true&lang=css"

import exportComponent from "/Users/williamconnell/Desktop/Minilogue Project/xdpatch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03df671b"]])

export default __exports__